import { ProjectListSortType } from '@/connection/projects/get-projects';
import {
  SelectedBrandliveEvent,
  EventGroupTreeEntry,
  EventGroup,
  BrandliveEventListItem,
  EventsTotals,
  LoadingStatus,
} from '@/types/projects.types';
import { ReducerCreators } from '@reduxjs/toolkit';

export enum ProjectTimeTypes {
  Live = 'Live',
  Upcoming = 'Upcoming',
  All = 'All',
  TestEvents = 'Sandbox',
  Courses = 'Courses',
}

export interface GetProjectOptions {
  pageSize: number;
  sort: ProjectListSortType | null;
  searchCriteria: string;
  time: ProjectTimeTypes;
  offset: number;
  append?: boolean;
}

export enum ProjectsDisplayView {
  Grid = 'grid',
  List = 'list',
}

export interface ProjectsState {
  projects: SelectedBrandliveEvent[];
  projectsListForSeries: SelectedBrandliveEvent[];
  projectsListForSeriesMap: Record<string, SelectedBrandliveEvent>;
  projectsError: boolean;
  projectsLoading: boolean;
  projectsTotals: EventsTotals | null;
  projectsInitialLoaded: boolean;
  getProjectsOptions: GetProjectOptions;
  gettingProjectByOption: keyof GetProjectOptions | null;
  getProjectsListForSeriesOptions: GetProjectOptions;
  projectToDelete: string | null;
  projectToEdit: string | null;
  projectsDisplayView: ProjectsDisplayView;
  projectsList: BrandliveEventListItem[];
  projectsListLoading: boolean;
  projectsListError: boolean;
  projectGroups: EventGroup[] | null;
  loadingProjectGroupsStatus: LoadingStatus;
  selectedProjectGroup: string;
  addProjectsToGroup: string[];
  groupError: string;
  groupToDelete: string | null;
  groupToEdit: string | null;
  showCreateGroupModal: boolean;
  projectGroupTree: EventGroupTreeEntry | null;
  projectGroupTreeNameMap: Record<string, string> | null;
  gettingGroupTree?: boolean;
}

export type ProjectsReducerCreator = ReducerCreators<ProjectsState>;
